import styled from 'styled-components';
import { colors } from '../../colors';
import { Select as antSelect } from 'antd';

export const Dropdown = styled(antSelect)<{ isValid: boolean }>`
  max-width: max-content;
  width: max-content;
  min-width: 146px;
  border: ${({ isValid }) =>
    isValid ? '1px solid #d2d2d2' : `1px solid ${colors.red30}`};
  border-radius: 8px;
  padding: 3px 0px;

  &:not(.ant-select-customize-input) .ant-select-selector {
    border-radius: 8px !important;
    border: 0px !important;
  }
  height: max-content !important;
`;
export const Item = styled(antSelect.Option)``;

export const Title = styled.h3`
  font-weight: 700;
  font-size: 16px;
  color: ${colors.black};
  font-family: 'Dm Sans';
  margin-bottom: 5px;
  margin-top: 6px;
`;
export const Subtitle = styled.p`
  font-weight: 400;
  font-size: 14px;
  color: ${colors.grey80};
  font-family: 'Dm Sans';
  padding-bottom: 7px;
`;

export const dropdownStyles = {
  width: '305px',
  border: '1px solid #E8E8EA !important',
  borderRadius: '8px',
  boxShadow: 'none',
  maxHeight: 'max-content !important',
  position: 'fixed',
};

export const RightChild = styled.h5`
  font-weight: 500;
  font-size: 14px;
  font-family: 'Dm Sans';
  margin-bottom: 5px;
  margin-top: 8px;
  color: ${colors.grey80};
`;

export const Flex = styled.div`
  display: flex;
  justify-content: space-between;
`;
